import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Header as HeaderLayout } from '@playbookux/playbook-web-core';

export const StyledModal = styled(SemanticModal).attrs(() => ({
  size: 'medium',
}))`
  padding: 20px 40px;
  width: 920px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  min-height: 620px;
  max-height: 700px;
  max-width: 100%;
`;

export const Title = styled(HeaderLayout)`
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ContainerTitle = styled.div`
  padding-top: 9px;
`;

export const ContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
  overflow: auto;
  margin-top: 5px;
`;

export const ContainerTabs = styled.div`
  display: flex;
  padding-bottom: 20px;
  flex-direction: row;
`;

export const Tab = styled.div`
  margin: 10px 20px 10px 0px;
  padding: 10px;
  border-radius: 3px;
  width: fit-content;
  cursor: pointer;
  ${({ selected }) => selected && 'background-color: #E9F0FF'}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0;
  flex-grow: 1;
  width: 100%;
`;

export const ContainerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0 0 0;
  background: #fff;
`;
